import { render, staticRenderFns } from "./CooperationMedicine.vue?vue&type=template&id=3983bdd2"
import script from "./CooperationMedicine.vue?vue&type=script&lang=js"
export * from "./CooperationMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3983bdd2')) {
      api.createRecord('3983bdd2', component.options)
    } else {
      api.reload('3983bdd2', component.options)
    }
    module.hot.accept("./CooperationMedicine.vue?vue&type=template&id=3983bdd2", function () {
      api.rerender('3983bdd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Cooperation/CooperationMedicine.vue"
export default component.exports